<template>
  <div class="container-fluid ib-auth-bg">
    <loading class="register-overlay" v-show="showLoader"/>

    <div class="row">
      <div class="col-md-4 offset-md-4 px-5">
        <div class="jbl-otp-h-right jbl-otp-right">

          <div class="text-center d-block my-5">
            <router-link :to="{ name: 'Home' }">
              <img alt="Logo Icon" class="img-fluid in-fluid-70" :src="require('@/assets/images/ib-logo.svg')" />
            </router-link>
          </div>

          <h5 class="ib-auth-desc">Please Enter Your <span>New Password.</span></h5>
          <form @submit.prevent="UpdatePassword" id="updatePassword">
            <div>
              <div class="ib-input-field">
                <label class="jbl-label-sign">Password</label>
                <input type="password" class="ib-login-input" name="password" v-model="password" placeholder="Password">
              </div>

              <div v-if="errors.filter(x => x.field == 'password').length > 0">
                <div class="d-block jbl-text-danger">
                  <small class="text-danger">{{errors.filter(x => x.field == 'password')[0].message}}</small>
                </div>
              </div>
            </div>
            <div>
              <div class="ib-input-field">
                <label class="jbl-label-sign">Confirm Password</label>
                <input type="password" class="ib-login-input" name="confirm_password" v-model="confirmPassword" placeholder="Password" autocomplete="off">
              </div>

              <div v-if="errors.filter(x => x.field == 'confirm_password').length > 0">
                <div class="d-block jbl-text-danger">
                  <small class="text-danger">{{errors.filter(x => x.field == 'confirm_password')[0].message}}</small>
                </div>
              </div>
            </div>
            <div class="jbl-mx-auto">
              <button type="submit" class="ib-btn-primary ib-btn-hover ib-btn-width mt-4">Submit</button>
              <router-link :to="{ name: 'Home' }" class="ib-btn-outline ib-btn-hover mt-4 ml-3">Cancel</router-link>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import loading from '@/components/Loading/Loading'

  export default {
    name: 'UpdatePassword',
    components: {
      loading
    },
    data () {
      return {
        showLoader : false,
        password: '',
        confirmPassword: '',
        errors: []
      }
    },
    created () {
      const self = this;
      if(!self.$store.getters.isAuthenticated) {
        self.$store.commit("resetState");
        window.location.reload();
      }
    },
    methods: {
      UpdatePassword () {
        const self = this;
        self.errors = [];

        if (self.password == '') {
          self.errors.push({
            field: 'password',
            message: 'Password required'
          });
        }

        if (self.confirmPassword == '') {
          self.errors.push({
            field: 'confirm_password',
            message: 'Confirm password required'
          });
        }

        if(self.password.length < 6) {
          self.errors.push({
            field: 'password',
            message: 'Minimum 6 characters required for password'
          });
        }

        if(self.confirmPassword.length < 6) {
          self.errors.push({
            field: 'confirm_password',
            message: 'Minimum 6 characters required for confirm password'
          });
        }

        if (self.confirmPassword !== self.password) {
          self.errors.push({
            field: 'password',
            message: 'Password must match confirm password'
          });
        }

        if (self.errors.length > 0) {
          return false;
        }

        self.showLoader = true;

        var formData = new FormData(document.getElementById('updatePassword'));

        axios.post('customer/password/update', formData).then(function (response) {
          if (response.data.code == 200) {
            self.password = '';
            self.confirmPassword = '';
            $toast.success('Password Updated Successfully!!', { position: 'top-right' });
          } else {
            $toast.error(response.data.message, { position: 'top-right' })
            return false;
          }
          self.showLoader = false;
        }).catch(function (error) {
          if(error.response) {
            error.response.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      }
    }
  }
</script>

<style scoped>
  /* @media (max-width:450px) {
    .jbl-otp-right h5 {

    }
  } */
  @media(max-width:550px){
  .jbl-otp-right h5{
    font-size: 15px !important;
    font-family: "Futura PT Medium";
    font-weight: 500;
    line-height: 1.28;
    color: #5b6770;
  }
  .in-fluid-70{
    max-width: 70% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Auth/UpdatePassword.vue